import { createSlice } from "@reduxjs/toolkit";

export const infoSlice = createSlice({
  name: 'info',
  initialState: { socialNetworks: null },
  reducers: {
    getSocialNetworks: (state, { payload }) => {
      state.socialNetworks = payload
    }
  }
});

export const { getSocialNetworks } = infoSlice.actions
